import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MapPropTypes from '../../MapPropTypes';
import strings from '../../../strings';

export default class NonContinuous extends Component {
    static propTypes = {
        maxMonths: PropTypes.number.isRequired, // unused
        maxWeeks: PropTypes.number.isRequired, // unused
        monthCount: PropTypes.number.isRequired,
        onBlur: PropTypes.func.isRequired, // unused
        prices: MapPropTypes.PricingProps.isRequired,
        showWeeks: PropTypes.bool,
        updateMonthCount: PropTypes.func.isRequired,
        updateWeekCount: PropTypes.func,
        weekCount: PropTypes.number,
    };

    constructor(props) {
        super(props);
    }

    _getValue() {
        if (this.props.weekCount) {
            return '1 week';
        }
        return `${this.props.monthCount} month`;
    }

    _onChange(value) {
        const [amount, increment] = value.split(' ');
        const months = increment === 'week' ? 0 : Number(amount);
        const weeks = increment === 'month' ? 0 : Number(amount);

        this.props.updateWeekCount(weeks);
        this.props.updateMonthCount(months);
    }

    _renderOptions() {
        const result = [];

        this.props.showWeeks &&
            this.props.prices.weekly.forEach((price) => {
                const value = `${price.amount} week`;
                result.push(
                    <option key={value} value={value}>
                        {price.amount} {strings.weekAbbr}
                    </option>
                );
            });

        this.props.prices.monthly.forEach((price) => {
            const value = `${price.amount} month`;
            result.push(
                <option key={value} value={value}>
                    {price.amount} {strings.monthAbbr}
                </option>
            );
        });

        return result;
    }

    render() {
        return (
            <div className="row">
                <div className="m-l-xs col-xs-12">
                    <select
                        className="form-control p-y-sm"
                        value={this._getValue()}
                        onChange={(e) => this._onChange(e.target.value)}
                    >
                        {this._renderOptions()}
                    </select>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Cart/DurationInput/NonContinuous.jsx